// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-bg[data-v-d388dcc0]{height:70vh}@media (min-width:1920px){.img-bg[data-v-d388dcc0]{height:50vh}}", ""]);
// Exports
module.exports = exports;
